"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Page = void 0;

var _react = _interopRequireDefault(require("react"));

var _ollui = require("ollui");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Page = function Page(_ref) {
  var center = _ref.center,
      children = _ref.children,
      disableScroll = _ref.disableScroll,
      extend = _ref.extend,
      noPadding = _ref.noPadding,
      noPaddingTop = _ref.noPaddingTop,
      limitContentWidth = _ref.limitContentWidth;
  return /*#__PURE__*/_react["default"].createElement(_ollui.View, {
    extend: [rootCSS({
      center: center,
      disableScroll: disableScroll,
      noPadding: noPadding,
      noPaddingTop: noPaddingTop
    }), extend]
  }, limitContentWidth ? /*#__PURE__*/_react["default"].createElement(_ollui.View, {
    extend: contentCSS
  }, children) : children);
};

exports.Page = Page;

var rootCSS = function rootCSS(_ref2) {
  var center = _ref2.center,
      disableScroll = _ref2.disableScroll,
      noPadding = _ref2.noPadding,
      noPaddingTop = _ref2.noPaddingTop;
  return function (_ref3) {
    var _ref3$theme = _ref3.theme,
        colors = _ref3$theme.colors,
        grid = _ref3$theme.layout.grid,
        breakpoints = _ref3$theme.breakpoints;
    return _defineProperty({
      background: colors.contentBg,
      // position: "absolute",
      // top: 0,
      // left: 0,
      width: '100%',
      // height: "100%",
      padding: 4 * grid,
      extend: [{
        condition: center,
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, {
        condition: !disableScroll,
        style: {
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch'
        }
      }, {
        condition: disableScroll,
        style: {
          overflowY: 'hidden'
        }
      }, {
        condition: noPadding,
        style: {
          padding: 0
        }
      }, {
        condition: noPaddingTop,
        style: {
          paddingTop: 0
        }
      }]
    }, breakpoints.onlyS, {
      padding: 2 * grid
    });
  };
};

var contentCSS = function contentCSS(_ref5) {
  var maxContentWidth = _ref5.theme.layout.maxContentWidth;
  return {
    maxWidth: maxContentWidth,
    margin: '0 auto'
  };
};